<template>
  <v-card class="mb-4" outlined>
    <v-card-title>{{ title }}</v-card-title>
    <v-card-text>
      <template v-if="isRequired">
        <v-alert type="warning" text v-if="!paymentEnabled">Payment currently not available</v-alert>
        <v-alert type="info" dense text>
          {{ title }} Required: {{ formatCurrency(amount) }}
        </v-alert>
        <v-btn
            color="success"
            class="mr-4"
            @click="loadPaymentGateway(payment, paymentPlatform)"
            :disabled="payment == null || payment.cleared"
            :loading="loading"
        >
          Pay Now
        </v-btn>
        <v-btn
            text
            color="primary"
            @click="initializeTransaction()"
            v-if="!payment && paymentEnabled && isRequired"
        >
          <v-icon left>mdi-download</v-icon>
          Invoice
        </v-btn>
        <v-btn
            v-if="payment != null"
            text
            color="primary"
            @click="downloadInvoice(payment.transactionId)"
        >
          <v-icon left>mdi-download</v-icon>
          Download {{ payment?.cleared ? 'Receipt' : 'Invoice' }}
        </v-btn>
      </template>
      <v-alert
          v-else
          type="success"
          dense
          text
      >
        No {{ title }} Required
      </v-alert>
    </v-card-text>
    <loading-dialog :show="loading"></loading-dialog>
  </v-card>
</template>

<script>
import {formatCurrency} from "../../../shared/CurrencyUtil";
import Api from "@/main/api";
import ErrorResolver from "@/shared/ErrorResolver";
import {PaymentGateway} from "@/shared/PaymentGateway";
import GateWays from "@/shared/GateWays";
import Links from "@/shared/constants/Links";
import LoadingDialog from "@ui/components/LoadingDialog.vue";
import {mapGetters} from "vuex";

export default {
  name: 'FeePaymentCard',
  components: {LoadingDialog},
  methods: {
    formatCurrency,
    initializeTransaction() {
      if (this.getUser != null ) {
        if(this.paymentPlatform != null){
          const meth = this.feeType === 'hostel' ? Api.hostel.initializeHostelFee : (this.feeType === 'interest' ? Api.hostel.initializeInterestFee : Api.hostel.initializeMaintenanceFee)
          this.loading = true;
          meth(this.getUser.userId, this.session?.id)
              .then(res => {
                this.$notify({ type: 'success', message: 'Invoice generated' });
                this.$emit('payment', res.data)
                this.payment = res.data
                this.downloadInvoice(res.data.transactionId)
              }).catch(err => ErrorResolver.checkErrors(this, err))
              .finally(() => this.loading = false)
        }
      }
    },

    // invoice download
    downloadInvoice(invoice) {
      this.loading = true;

      Api.hostel.invoice(invoice)
          .then(res => {
            let fileURL = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', this.feeType + '-invoice.pdf');
            document.body.appendChild(fileLink);

            fileLink.click();
            fileLink.remove();
          }).catch(() => {
        // ErrorReslover.checkErrors(this, err);
        this.$notify({ type: 'error', message: 'Failed to download invoice' });
        // err.message = "Failed to Download Invoice"
      }).finally(() => this.loading = false)
    },

    loadPaymentGateway(payment, platform) {
      this.loading = true
      this.paymentGateway = new PaymentGateway(GateWays.REMITA, this, Links.payments.processInlinePayment)
      Api.paymentPlatforms.find(platform)
          .then(res => {
            if (this.paymentGateway != null) {
              // set config
              this.paymentConfig = res.data
              // if inline, initialize
              if (res.data.inline) {
                setTimeout(() => {
                  this.paymentGateway.initializeGateway(res.data, () => {
                    // make payment
                    this.makePayment(payment)
                    this.loading = false
                  })

                }, 1000)
              } else{ // not inline. make direct payment
                this.makePayment(payment)
              }
            } else {
              this.$notify({ type: 'error', message: 'No payment settings found' });
              this.loading = false
            }
          }).catch(err => {
        ErrorResolver.checkErrors(this, err)
        this.loading = false
      })
    },

    makePayment(payment) {
      if (payment != null) {
        if (this.paymentConfig.inline) {
          this.paymentGateway.makePayment({
            email: this.getUser.email,
            amount: payment.invoiceAmount,
            currency: 'NGN',
            invoice: payment.transactionId,
            paymentId: payment.id
          }, (data) => {
            // if its an applicant, logout 'em out
            window.location.reload()
          }, (invoice) => {
            // process
            // this.loading = true
            this.getPayment()
            Api.payment.processInline(invoice)
                .then(() => {
                  window.location.href = "/student#/accommodation"
                }).catch(err => {
              ErrorResolver.checkErrors(this, err)
              this.loading = false
            }).finally(() => this.loading = false)
          })
        } else {
          // payment should not be done inline
          // open window for payment
          this.loading = true
          window.location.href = payment.paymentLink
        }
      }
    },
  },

  props: {
    title: {
      type: String,
      required: true
    },
    amount: {
      type: [Number, null],
      required: false
    },
    isRequired: {
      type: Boolean,
      default: true
    },
    isPaid: {
      type: Boolean,
      default: false
    },
    feeType: {
      type: String,
      required: true
    },
    payment: {
      type: [Object, null],
      required: false
    },
    paymentPlatform: {
      type: [String, null],
      required: false
    },
    session: {
      type: [Object, null],
      required: false
    },
    paymentEnabled: {
      type: Boolean,
      required: true,
      default: false
    }
  },

  computed: {
    ...mapGetters(['getUser'])
  },

  data: () => ({
    loading: false,
    paymentGateway: null,
    paymentConfig: null,
  }),
};
</script>
